/**
 *  Usage:
 *  <div jv-mouseover-tooltip trigger-element-text="Hover Text">
 *      <!-- Content required for the tooltip something like below -->
 *      <div>
 *         <p>Tooltip Content</p>
 *      </div
 *  </div>
 */

angular.module('jv.Common.MouseoverTooltip', [])
    .directive('jvMouseoverTooltip', function() {
        return {
            restrict: 'A',
            transclude: true,
            scope: {
                triggerElementText: '@'
            },
            template: `
                <div class="mouseover-tooltip">
                    <a class="trigger-element">{{ triggerElementText }}</a>
                    <div class="content-wrapper" ng-transclude></div>
                </div>
            `,
            link: function(scope, element) {
                const tooltipContent = element?.find('.content-wrapper');

                element.on('mouseover', function() {
                    tooltipContent.css('display', 'block');
                });
        
                element.on('mouseout', function() {
                    tooltipContent.css('display', 'none');
                });

                scope.$on('$destroy', function() {
                    tooltipContent.remove();
                    element.off('mouseover');
                    element.off('mouseout');
                });
            }
        };
    });